import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  getSentimentsSummary,
  getAuditNeededCalls,
  getIssueContexts,
  getToolErrors,
  getResponseTimes,
  getSynchronizerLogs
} from './api';
import {
  SentimentsSummaryResponse,
  AuditNeededCallsResponse,
  IssueContextsResponse,
  ToolErrorsResponse,
  ResponseTimesResponse,
  SynchronizerLogsResponse
} from './types';

export function useGetSentimentsSummary(
  params: Record<string, any>,
  options?: UseQueryOptions<SentimentsSummaryResponse, Error>
) {
  return useQuery<SentimentsSummaryResponse>({
    queryKey: ['sentiments_summary', params],
    queryFn: () => getSentimentsSummary(params),
    ...options
  });
}

export function useGetAuditNeededCalls(
  params: Record<string, any>,
  options?: UseQueryOptions<AuditNeededCallsResponse, Error>
) {
  return useQuery<AuditNeededCallsResponse>({
    queryKey: ['audit_needed_calls', params],
    queryFn: () => getAuditNeededCalls(params),
    ...options
  });
}

export function useGetIssueContexts(options?: UseQueryOptions<IssueContextsResponse, Error>) {
  return useQuery<IssueContextsResponse>({
    queryKey: ['issue_contexts'],
    queryFn: () => getIssueContexts(),
    ...options
  });
}

export function useGetToolErrors(params: Record<string, any>, options?: UseQueryOptions<ToolErrorsResponse, Error>) {
  return useQuery<ToolErrorsResponse>({
    queryKey: ['tool_errors', params],
    queryFn: () => getToolErrors(params),
    ...options
  });
}

export function useGetResponseTimes(
  params: Record<string, any>,
  options?: UseQueryOptions<ResponseTimesResponse, Error>
) {
  return useQuery<ResponseTimesResponse>({
    queryKey: ['response_times', params],
    queryFn: () => getResponseTimes(params),
    ...options
  });
}

export function useGetSynchronizerLogs(
  params: Record<string, any>,
  options?: UseQueryOptions<SynchronizerLogsResponse, Error>
) {
  return useQuery<SynchronizerLogsResponse>({
    queryKey: ['synchronizer_logs', params],
    queryFn: () => getSynchronizerLogs(params),
    ...options
  });
}
